var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFinance24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3169 6.69168C17.1997 6.80889 17.0408 6.87473 16.875 6.87473H16.25V14.9997H17.5V16.2497H2.5V14.9997H3.75V6.87473H3.125C2.95924 6.87473 2.80027 6.80889 2.68306 6.69168C2.56585 6.57447 2.5 6.41549 2.5 6.24973V4.37473C2.50005 4.24629 2.53968 4.12098 2.61349 4.01586C2.6873 3.91073 2.79171 3.83091 2.9125 3.78723L9.7875 1.28723C9.92482 1.23759 10.0752 1.23759 10.2125 1.28723L17.0875 3.78723C17.2083 3.83091 17.3127 3.91073 17.3865 4.01586C17.4603 4.12098 17.4999 4.24629 17.5 4.37473V6.24973C17.5 6.41549 17.4342 6.57447 17.3169 6.69168ZM10 2.53723L3.75 4.81223V5.62473H16.25V4.81223L10 2.53723ZM8.75 6.87473V14.9997H11.25V6.87473H8.75ZM7.5 6.87473H5V14.9997H7.5V6.87473ZM12.5 14.9997H15V6.87473H12.5V14.9997ZM1.25 18.7498V17.4998H18.75V18.7498H1.25Z",
    fill: "#E9EEF7"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance24);
export default __webpack_public_path__ + "static/media/Finance24.64d861e2e3cc88b5f523854f486b0309.svg";
export { ForwardRef as ReactComponent };